<template>
  <div class="wrap relative">
    <SiteHeader></SiteHeader>
    <case-studies-index />
    <ContentSection skew="right" id="our-people" class="z-10 bg-white">
      <div class="max-w-5xl mx-auto">
        <div class="sect-contact">
          <div class="inner relative">
            <div class="sect-content bg-grey-100 -mt-48">
              <svgicon
                name="footer-contact-us"
                class="orange"
                color="#ffffff"
                width="40"
                height="40"
                title="Contact us"
              />
              <h3>Want to know more about any of these case studies?</h3>
              <div>
                <button
                  type="button"
                  class="button button--primary relative"
                  @click="Store.toggleContactUsModal()"
                >
                  Contact us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentSection>
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
// var Sticky = require('sticky-js');
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import CaseStudiesIndex from '@/components/CaseStudiesIndex.vue';
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'CaseStudies',
  components: {
    SiteHeader,
    SiteFooter,
    CaseStudiesIndex,
    ContentSection
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {
    // contactModalOpen: {
    //   get: function() {
    //     return this.Store.contactModalOpen;
    //   },
    //   set: function(newVal) {
    //     this.Store.contactModalOpen = newVal;
    //   }
    // }
  }
};
</script>

<style lang="scss"></style>
